import { classUserSelectors, createAppSelector, selectCurrentUserId, userSelectors } from "./base";
import { selectIsClassSessionInPerson, selectIsClassSessionVirtual } from "./class-session";

export const selectUserByClassUserId = createAppSelector(
  [classUserSelectors.selectById, userSelectors.selectEntities],
  (classUser, users) => {
    return classUser?.user_id && classUser.user_id in users ? users[classUser.user_id] : null;
  },
);

export const selectUserIdByClassUserId = createAppSelector(
  [classUserSelectors.selectById],
  (classUser) => classUser?.user_id || null,
);

export const selectClassUserByUserId = createAppSelector(
  [(state, userId: string) => userId, classUserSelectors.filterForCurrentSection],
  (userId, classUsers) => classUsers.find((cu) => cu.user_id === userId) || null,
);

export const selectClassUserIdByUserId = createAppSelector(
  [selectClassUserByUserId],
  (classUser) => classUser?.id || null,
);

export const selectClassUserIsInVirtualClassByUserId = createAppSelector(
  [selectClassUserByUserId, selectIsClassSessionVirtual],
  (classUser, isClassSessionVirtual) =>
    isClassSessionVirtual && (classUser?.is_in_class_session || false),
);

export const selectCurrentClassUser = createAppSelector(
  [classUserSelectors.filterForCurrentSection, selectCurrentUserId],
  (classUsers, currentUserId) =>
    (currentUserId && classUsers.find((cu) => cu.user_id === currentUserId)) || null,
);

export const selectCurrentClassUserId = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.id || null,
);

export const selectCurrentClassUserReaction = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.reaction || null,
);

export const selectCurrentClassUserVote = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.vote || null,
);

export const selectCurrentClassUserIsInClassSession = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.is_in_class_session || false,
);

// NOTE: to check if the current class user is in a virtual class session, use the useAv() hook instead.
export const selectCurrentClassUserIsInPersonClass = createAppSelector(
  [selectCurrentClassUserIsInClassSession, selectIsClassSessionInPerson],
  (isInClassSession, isClassSessionInPerson) => isClassSessionInPerson && isInClassSession,
);

export const selectCurrentClassUserIsPerformingAvCheck = createAppSelector(
  [selectCurrentClassUser],
  (classUser) => classUser?.is_performing_av_check || false,
);

export const selectBreakoutGroupIdByClassUserId = createAppSelector(
  [classUserSelectors.selectById],
  (classUser) => classUser?.breakout_group_id || null,
);

export const selectIsHandRaisedByClassUserId = createAppSelector(
  [classUserSelectors.selectById],
  (classUser): boolean => !!classUser?.hand_raised_at,
);
